import React, { useState } from 'react';
import cx from 'classnames';

import { Content } from 'LegacySBCRA/Content/Content';
import { ClickableCard } from 'Storybook/components/local/ClickableCard';
import { ContentSection as SEOContentSection, ContentSectionProps } from 'Storybook/components/local/ContentSection';

import { useBreakpoint } from '../../../../../components/misc/Breakpoints/Breakpoints';
import { usePageRefEvents } from '../../Pages/CheckerRouter.utils';
import { ContentImage } from '../ContentImage/ContentImage';

import { toolsSectionContent } from './ToolsSection.helpers';

import styles from './ToolsSection.scss';

type ToolsSectionProps = {
  analyticsEvents: {
    onLoad: () => void;
    onTileClick: (params: { label: string; url: string }) => void;
  };
  videoSectionContent: ContentSectionProps;
};

export const ToolsSection = ({ analyticsEvents, videoSectionContent }: ToolsSectionProps) => {
  const [loadBgImg, setLoadBgImg] = useState(false);

  const onCardClick = (label: string, route: string) =>
    analyticsEvents.onTileClick({ label, url: route });

  const { minWidth: breakpoints } = useBreakpoint();
  const { breakpointTablet } = breakpoints;

  const onSectionLoad = () => {
    setLoadBgImg(true);
    analyticsEvents.onLoad();
  };

  const { setRef } = usePageRefEvents({ onRefTrigger: onSectionLoad });

  const { imgAlt, imgSrc, ...contentDetails } = videoSectionContent;

  return (
    <div ref={(ref) => setRef(ref)} className={styles.component} data-testid='checker-tools'>
      <Content className={styles.wrapper}>
        <SEOContentSection
          data-seo-content
          {...contentDetails}
          imgSrc={<ContentImage {...{ imgAlt }} isStaticImageSize imgSrc={imgSrc as string} />}
          theme='black'
        />
        {toolsSectionContent.map(({ label, type, ...props }) => (
          <div key={label} className={cx(styles[type], styles.toolsCard, {
            [styles.loadBgImg]: loadBgImg,
          })}>
            <ClickableCard
              data-clickable-card
              {...{ ...props }}
              data-clickable-card-size={ breakpointTablet ? 'large' : 'medium' }
              onClick={() => onCardClick(label, props.link.route)}
            />
          </div>
        ))}
      </Content>
    </div>
  );
};
